import React, { useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import { DynamicVideosComponent, QuickReadCategory } from "@/components/PageHome/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import VideoInfo from "@/components/VideoInfo";
import { getResourceListingURL } from "@/helpers";
import { FILTER_MAPPING } from "@/helpers/constants";
import { fetchVideosAPI } from "@/components/VideosComponent/api";
import styles from "./VideosComponent.module.scss";

interface VideoProps {
  data: DynamicVideosComponent;
  userAgent: DeviceInfo;
  assetPosition?: number;
  pageCategory?: string;
  firstFoldData?: any;
}

const VideosComponent: React.FC<VideoProps> = ({ data, userAgent, assetPosition, pageCategory, firstFoldData }) => {
  const { Title, Description, Categories, videos: initialVideos } = data;
  const categories = Categories?.data;

  const [activeCategory, setActiveCategory] = useState<string>(categories?.[0]?.attributes.Slug);
  const [videos, setVideos] = useState(initialVideos);

  const handleTabChange: (slug: string) => void = async (slug) => {
    try {
      const response = await fetchVideosAPI(slug);

      if (response?.length) {
        setVideos(response);
      } else {
        setVideos([]);
      }
    } catch (err) {
      console.error(err);
      setVideos([]);
    }

    setActiveCategory(slug);
  };

  return (
    <section className={`${styles.root} spacingBetweenSections`}>
      <div className={"container"}>
        <SectionHeader title={Title} subTitle={Description} userAgent={userAgent} />

        {!!categories?.length && (
          <div className={styles.tabsWrapper}>
            {categories.map(({ id, attributes }: QuickReadCategory) => {
              const { CategoryName, Slug } = attributes;
              const isActive = activeCategory === Slug;

              return (
                <button
                  type={"button"}
                  onClick={() => handleTabChange(Slug)}
                  key={id}
                  className={`${styles.tab} ${isActive ? styles.active : ""}`}
                >
                  {CategoryName}
                </button>
              );
            })}
          </div>
        )}

        <VideoInfo
          desktopItems={4}
          videos={videos}
          userAgent={userAgent}
          ctaURL={getResourceListingURL({ [FILTER_MAPPING.category]: [activeCategory || pageCategory] }, "video")}
          sectionTitle={Title}
          assetPosition={assetPosition}
        />
      </div>
    </section>
  );
};

export default VideosComponent;
